import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from '@/store';
import { loadRuntimeConfig, getApiBase } from '@/config';
import { setClientBaseURL } from '@/api/client';
import App from './App';
import './index.css';

async function bootstrap() {
  await loadRuntimeConfig();
  setClientBaseURL(getApiBase());
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

bootstrap().then(() => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
});
